import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL || '/api',
  timeout: 5000, // Optional timeout
  headers: {
    'Content-Type': 'application/json',
  },
});

export default {
  install(app) {
    app.config.globalProperties.$axios = axiosInstance;
  },
};
